import { useEffect, type ReactNode } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { usePendingPolicyAck } from "@/hooks/usePolicyAck";

/**
 * Redirects authenticated users with a pending policy campaign to /policy-ack.
 */
export function PolicyAckGate({ children }: Readonly<{ children: ReactNode }>) {
  const { user, loading, mfaChallenge } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { data: pending, isLoading } = usePendingPolicyAck(Boolean(user));

  useEffect(() => {
    if (loading || mfaChallenge || !user || isLoading) {
      return;
    }
    if (location.pathname.startsWith("/policy-ack")) {
      return;
    }
    if (pending?.campaign_id) {
      navigate("/policy-ack", { replace: true });
    }
  }, [user, loading, mfaChallenge, isLoading, pending, location.pathname, navigate]);

  return <>{children}</>;
}
